import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { AnalyticsTracker } from "@/components/cre/AnalyticsTracker";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import IncidentIntake from "@/pages/IncidentIntake";
import WarRoom from "@/pages/WarRoom";
import SharedWarRoom from "@/pages/SharedWarRoom";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AdminDashboard from "@/pages/AdminDashboard";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import CheckoutCancel from "@/pages/CheckoutCancel";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Trust from "@/pages/Trust";
import Preview from "@/pages/Preview";
import PreviewResult from "@/pages/PreviewResult";
import AIIncidentManagement from "@/pages/seo/AIIncidentManagement";
import AIOpsIncidentReasoning from "@/pages/seo/AIOpsIncidentReasoning";
import RootCauseAnalysisAI from "@/pages/seo/RootCauseAnalysisAI";
import MajorIncidentManagement from "@/pages/seo/MajorIncidentManagement";
import ITDowntimeReduction from "@/pages/seo/ITDowntimeReduction";
import Demo from "@/pages/seo/Demo";

export default function App() {
  return (
    <div className="App min-h-screen bg-[#f8fafc] text-[#0f172a] font-body">
      <AuthProvider>
        <BrowserRouter>
          <AnalyticsTracker />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/incidents/new" element={<IncidentIntake />} />
            <Route path="/incidents/:id" element={<WarRoom />} />
            <Route path="/share/:token" element={<SharedWarRoom />} />
            <Route path="/billing/success" element={<CheckoutSuccess />} />
            <Route path="/billing/cancel" element={<CheckoutCancel />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/trust" element={<Trust />} />
            <Route path="/preview" element={<Preview />} />
            <Route path="/preview/:incidentId" element={<PreviewResult />} />
            <Route path="/ai-incident-management" element={<AIIncidentManagement />} />
            <Route path="/aiops-incident-reasoning" element={<AIOpsIncidentReasoning />} />
            <Route path="/root-cause-analysis-ai" element={<RootCauseAnalysisAI />} />
            <Route path="/major-incident-management" element={<MajorIncidentManagement />} />
            <Route path="/it-downtime-reduction" element={<ITDowntimeReduction />} />
            <Route path="/demo" element={<Demo />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <Toaster position="top-right" richColors theme="dark" />
    </div>
  );
}
